import type { ManagementTranslations } from '../en-US/management.translations';

const managementTranslations: Partial<ManagementTranslations> = {
  title: 'BiteCritic Beheer',
  dashboard: 'Dashboard',
  users: 'Gebruikersbeheer',
  settings: 'Instellingen',
  foods: {
    title: 'Voedselbeheer',
    createNew: 'Nieuw Voedsel Toevoegen',
    id: 'ID',
    name: 'Naam',
    category: 'Categorie',
    country: 'Land',
    status: 'Status',
    createdAt: 'Aangemaakt op',
    actions: 'Acties',
    noFoodsFound: 'Geen voedsel gevonden',
    searchPlaceholder: 'Zoek voedsel...',
    allStatuses: 'Alle Statussen',
    allCategories: 'Alle Categorieën',
    sortNewest: 'Nieuwste Eerst',
    sortOldest: 'Oudste Eerst',
    sortNameAZ: 'Naam A-Z',
    sortNameZA: 'Naam Z-A',
    showing: 'Toont {{from}} tot {{to}} van {{total}} voedsel',
    confirmDelete: 'Weet je zeker dat je dit voedsel wilt verwijderen?',
    approve: 'Goedkeuren',
    reject: 'Afwijzen',
    createFood: 'Nieuw Voedsel Aanmaken',
    editFood: 'Voedsel Bewerken',
    viewFood: 'Voedseldetails Bekijken',
    namePlaceholder: 'Voer voedselnaam in',
    descriptionPlaceholder: 'Voer voedselbeschrijving in',
    selectCategory: 'Selecteer een categorie',
    selectCountry: 'Selecteer een land',
    selectStatus: 'Selecteer een status',
    imageUrl: 'Afbeelding URL',
    imageUrlPlaceholder: 'Voer afbeelding URL in',
    imagePreview: 'Afbeeldingsvoorbeeld',
    rowsPerPage: '{{count}} per pagina',
    translations: 'Vertalingen',
    description: 'Beschrijving',
    formatJson: 'JSON Formatteren',
    jsonPlaceholder: 'Voer voedselgegevens in JSON-formaat in',
    jsonInstructions: 'JSON-formaat Instructies',
    jsonInstructionName: 'Naam is verplicht en moet een string zijn',
    jsonInstructionCategory: 'CategoryId is verplicht en moet een nummer zijn',
    jsonInstructionCountry: 'CountryId is optioneel en moet een nummer zijn',
    jsonInstructionStatus: 'Status moet een van de volgende zijn',
    jsonInstructionTranslations:
      'Vertalingen moeten een record zijn van taalcodes naar vertaalobjecten',
    jsonUpdateError: 'Fout bij het bijwerken van {{field}}: {{error}}',
    hideFilters: 'Filters Verbergen',
    showFilters: 'Filters Tonen',
    totalItems: '{{count}} items totaal',
    aiPrompt: {
      title: 'Genereer Voedselgegevens met AI',
      description: 'Gebruik AI om voedselgegevens te genereren',
      inputLabel: 'Voedselnaam',
      inputPlaceholder: 'Voer een voedselnaam in',
      buttonText: 'Genereer met AI',
      copyPrompt: 'Kopieer Prompt',
      openInChatGPT: 'Open in ChatGPT',
      promptCopied: 'Prompt gekopieerd naar klembord!',
      instructions: 'Instructies:',
      step1: '1. Voer een voedselnaam in',
      step2: '2. Klik op "Genereer met AI" of kopieer de prompt',
      step3: '3. Plak de prompt in ChatGPT of klik op "Open in ChatGPT"',
      step4:
        '4. Kopieer de JSON-respons en gebruik deze om een nieuw voedselitem te maken',
    },
  },
  languages: {
    en: 'Engels',
    nl: 'Nederlands',
    tr: 'Turks',
    de: 'Duits',
    fr: 'Frans',
    es: 'Spaans',
    it: 'Italiaans',
    pt: 'Portugees',
  },
};

export default managementTranslations;
